import Main from './pages/Main.vue'
import SearchReportPage from './pages/SearchReportPage.vue'
import ScheduleTaskPage from './pages/ScheduleTaskPage.vue'

export default [
  {
    path: '/crawler',
    component: Main,
    redirect: { name: 'crawler-task' },
    children: [
      {
        path: 'task',
        name: 'crawler-task',
        component: ScheduleTaskPage,
        meta: {
          title: 'TaskSetting'
        }
      },
      {
        path: 'report',
        name: 'crawler-report',
        component: SearchReportPage,
        meta: {
          title: 'SearchReport'
        }
      }
    ]
  }
]
